"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
var _fetching = require("@ori/fetching");
/* istanbul ignore file @preserve */

const labels = exports.labels = (0, _fetching.gql)`
  fragment ProductLabels on ProductLabel {
    labelKey
    productLabelDomain
    title
  }
`;
//# sourceMappingURL=labels.js.map